var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticStyle:{"color":"#ffffff"},attrs:{"color":"blue","loading":_vm.loading},on:{"click":() => _vm.loadReportFile()}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" mdi-microsoft-excel ")]),_vm._v(" Descargar ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }